import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useParams } from 'react-router-dom';
import useFetchList from 'hooks/useFetchList';
import { useSelector } from 'react-redux';
import { NULL_QUERY_DELAY } from '../../Shared/constants';
import { GET_PROGRAMS_COLUMNS } from '../constants';
import QhsTable from '../../Shared/Table/Table';
import { convertDataFromApi, useGenerateColumns } from '../../Shared/Table/helpers';
import { ALL_ROUTES, PATIENT_TABLE_NAMES } from '../../../config/routes';
import { AppRouteContext } from '../../../contexts';
import { TABLE_KEYS } from '../../../redux_store/reducer/reducers/tableReducer/tableReducer';

const ProgramList = ({
                       setFilterStyle,
                       setTotalCount,
                       tableTitle,
                       q,
                       hideMenuActions,
                       columnList,
                     }) => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const { accountUuid: paramAccountUuid } = useParams();
  const {
    metadata: { currentAccount },
    isDistributionSponsor,
  } = useSelector((state) => state.user);
  const [modifiedReportables, setModifiedReportables] = useState();
  const tableKey = isDistributionSponsor ? TABLE_KEYS.programsDSTable : TABLE_KEYS.programsTable;
  const columns = useGenerateColumns(columnList || GET_PROGRAMS_COLUMNS, tableKey, {}, {}).columns;
  const fields = columns.map((columnData) => columnData.accessorKey).join();
  const { setAppRoute } = useContext(AppRouteContext);
  const baseEndpoint = `/accounts/${paramAccountUuid || currentAccount.uuid}/programs`;
  const {
    items,
    totalAccountsCount,
    totalCount,
    completionRate,
    aggregations,
    reloadData,
    clearFilter,
    sort,
    onSort,
    filter,
    onFilter,
    loading: dataLoading,
    onLoadMoreRows,
  } = useFetchList({
    baseEndpoint,
    baseParams: {
      fields: fields,
      q: q || undefined,
    },
    tableKey,
    canLoad: fields.length,
  });

  const [prevTotalCount, setPrevTotalCount] = useState(totalCount);

  useEffect(() => {
    if (items) {
      const newModifiedItems = convertDataFromApi(items, tableKey, filter);
      setModifiedReportables(newModifiedItems);
    }
  }, [items]);

  useEffect(() => {
    if (prevTotalCount !== totalCount) {
      setFilterStyle(!!(filter?.reduce((accumulator, { value }) => {
        return accumulator + value.toString().replaceAll(' ', '').length;
      }, 0)));
      setPrevTotalCount(totalCount);
      setTotalCount && setTotalCount(totalCount);
    }
  }, [filter, totalCount]);

  const reloadReportableList = (hasFilter) => {
    !hasFilter ? clearFilter() : reloadData({ delay: NULL_QUERY_DELAY });
  };

  const handleRowClick = (props) => {
    const { uuid, accountUUID, patientUUID, title } = props;
    const isItChildAccount = accountUUID !== currentAccount.uuid && isDistributionSponsor;
    setAppRoute({
      path: (isItChildAccount ? ALL_ROUTES.program.dashboardDS : ALL_ROUTES.program.dashboard).path,
      params: {
        currentAccountUuid: currentAccount.uuid,
        accountUuid: isItChildAccount ? accountUUID : null,
        patientUuid: patientUUID,
        programUuid: uuid,
        tableName: PATIENT_TABLE_NAMES.assessment,
      },
      title: `${titles.programDashboard}: ${title}`,
    });
  };

  return <QhsTable
    tableKey={tableKey}
    columns={columns}
    data={modifiedReportables || []}
    fetchNextPage={onLoadMoreRows}
    isFetching={dataLoading}
    isLoading={dataLoading && !modifiedReportables}
    totalRowCount={totalCount}
    sorting={sort}
    setSorting={onSort}
    filter={filter}
    setFilters={onFilter}
    tableTitle={tableTitle}
    showRefreshTableButton
    onRowClick={handleRowClick}
    reloadData={reloadReportableList}
    // menuActions={!hideMenuActions && <TableActions
    //   totalCount={totalCount}
    //   tableSort={sort}
    //   tableFilter={filter}
    //   columns={columns}
    //   aggregations={aggregations}
    // />}
  />;
};

export default ProgramList;
